import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LixaniFiles } from 'lixani-lib-graphql';
import { Translation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import DialogHeader from 'components/DialogHeader/DialogHeader';
import Spinner from 'components/Spinner/Spinner';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    ...theme.component.dialogPaper,
    border: theme.component.border,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 24,
      marginRight: 24,
    },
  },
  dialogContent: {
    paddingTop: 16,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  imageGrid: {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    maxWidth: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
  confirmGrid: {
    textAlign: 'center',
  },
  dialogActions: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  deleteButton: {
    background: theme.palette.danger.main,
    borderRadius: '4px',
  },
}));

function DescriptionDialog(props) {
  const theme = useTheme();
  const [src, setSrc] = useState(null);
  const { picture } = props;
  const classes = useStyles();

  return (
    <Translation ns={['common']}>
      {(t) => (
        <>
          <Dialog
            aria-labelledby="project-bank-preview-dialog"
            classes={{ paper: classes.dialogPaper }}
            fullWidth
            maxWidth="sm"
            open={props.open}
            onClose={props.onClose}
          >
            <DialogHeader title={picture.name} onClose={props.onClose} />
            <DialogContent className={classes.dialogContent}>
              <Grid
                container
                spacing={2}
                direction="column"
                className={classes.gridContainer}
              >
                <Grid item className={classes.confirmGrid}>
                  <Typography>{t('file.delete_picture_confirm')}</Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions className={classes.dialogActions}>
              <Button onClick={props.onClose}>{t('common.cancel')}</Button>
              <Button className={classes.deleteButton} onClick={props.onDelete}>
                {t('common.delete')}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Translation>
  );
}

DescriptionDialog.defaultProps = {
  picture: {
    name: '',
    description: '',
    createdAt: '',
    key: '',
  },
};

DescriptionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  picture: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

export default LixaniFiles(DescriptionDialog);
